export const PublicAccessRuleTypes = {
  PUBLIC: 'PUBLIC',
  PASSWORD: 'PASSWORD',
  LIST_MEMBERSHIP: 'LIST_MEMBERSHIP',
  SSO_LOGIN: 'SSO_LOGIN',
  MEMBERSHIP_LOGIN: 'MEMBERSHIP_LOGIN',
  SSO_WITH_LIST_MEMBERSHIP: 'SSO_WITH_LIST_MEMBERSHIP',
  ACCESS_GROUP_MEMBERSHIP: 'ACCESS_GROUP_MEMBERSHIP'
};
export const ListBasedPublicAccessRuleTypes = [PublicAccessRuleTypes.LIST_MEMBERSHIP, PublicAccessRuleTypes.SSO_WITH_LIST_MEMBERSHIP];